import axios from './Axios';
import { error, success } from "./ResponseHandler";
import store from '../store';
import { setSweetConfig } from '../features/sweetAlert/sweetAlertSlice';
import CONSTANT from '../constants/Constant';
import GLOBAL from "../global";
import { getTenantFeatures } from '../features/tenantFeatures/useTenantFeature';

const { REACT_APP_BASE_API_URL } = process.env;
const SAVE_ERROR_LOG = `${REACT_APP_BASE_API_URL}/api/base/ErrorLog`;
const RESPONSE_TYPE = { responseType: 'text' };


class ErrorLogService {
    async saveErrorLog(payload) {
        try {
            let alertMessage = <span>Unfortunately, we're currently unable to process your request. Please contact support.</span>;

            const { isSpinealignEnabled } = getTenantFeatures();
            if (isSpinealignEnabled) {
                alertMessage = <span>
                            Unfortunately, we're currently unable to process your request. Please contact <a href="mailto://support@mybackhub.com">support@mybackhub.com</a>.
                       </span>;
            }

            // Show SweetAlert when error log is saved
            store.dispatch(setSweetConfig({
                title: 'Internal Error',
                message: alertMessage,
                type: CONSTANT.ALERT_TYPE.ERROR,
                showConfirmBtn: true,
                showCancelBtn: false,
                confirmBtnText: 'OK',
                onConfirmKey: 'ERROR_LOG_CLOSE',
                onCancelKey: null,
                onCloseKey: null
            }));

            const response = await axios.post(SAVE_ERROR_LOG, payload, RESPONSE_TYPE);

            return success(response);
        } catch (e) {
            return error(e);
        }
    }

    // Dynamic error log creator - accepts object or individual parameters
    createErrorLogPayload = (payloadOrTenant, Source, HelpLink, StackTrace, Message, DeviceInfo, RequestUrl, TestId, IncomingData) => {
        // If first parameter is an object, use it directly
        if (typeof payloadOrTenant === 'object' && payloadOrTenant !== null) {
            const {
                Tenant = "unknown",
                Source = "unknown", 
                HelpLink = "",
                StackTrace = "unknown",
                Message = "unknown",
                Application = "Patient Portal",
                Version = "1.0.0",
                DeviceInfo = "unknown",
                RequestUrl = "unknown",
                CorrelationId = "",
                TestId = "unknown",
                IncomingData = {}
            } = payloadOrTenant;

            return {
                Tenant,
                Source,
                HelpLink,
                StackTrace,
                Message,
                Application,
                Version,
                DeviceInfo,
                RequestUrl,
                CorrelationId,
                TestId,
                IncomingData: typeof IncomingData === 'string' ? IncomingData : JSON.stringify(IncomingData)
            };
        }

        // Otherwise use individual parameters
        return {
            Tenant: payloadOrTenant || "unknown",
            Source: Source || "unknown",
            HelpLink: HelpLink || "",
            StackTrace: StackTrace || "unknown",
            Message: Message || "unknown",
            Application: "Patient Portal",
            Version: "1.0.0",
            DeviceInfo: DeviceInfo || "unknown",
            RequestUrl: RequestUrl || "unknown",
            CorrelationId: "",
            TestId: TestId || "unknown",
            IncomingData: typeof IncomingData === 'string' ? IncomingData : JSON.stringify(IncomingData || {})
        };
    }

    // Convenience method for quick error logging
    async logError(errorPayload, options = {}) {
        const { fireAndForget = false, fallbackToConsole = true } = options;

        if (fireAndForget) {
            // Don't await - fire and forget for performance
            this.saveErrorLog(errorPayload).catch(logError => {
                if (fallbackToConsole) {
                    console.warn("Failed to log error:", logError);
                }
            });
            return;
        }

        try {
            return await this.saveErrorLog(errorPayload);
        } catch (e) {
            if (fallbackToConsole) {
                console.error("Failed to log error:", e);
            }
            throw e;
        }
    }
}

export default new ErrorLogService();
